var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ionos-chip',{attrs:{"link":"","target":"_blank","href":_vm.branch.webUrl}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-source-branch")]),_c('div',{staticClass:"body-1"},[_vm._v(" "+_vm._s(_vm.branch.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }